import { useState, type ComponentProps, type ReactElement } from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { cn } from '@/lib/utils';

import AuthField from './AuthField';

type PasswordFieldProps = Omit<ComponentProps<typeof AuthField>, 'type' | 'endAdornment'>;

// A new-password field with its own show/hide toggle. Edge draws its own reveal button inside
// password inputs, so that one is hidden.
function PasswordField({ label, className, ...fieldProps }: PasswordFieldProps): ReactElement {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOff : Eye;

  return (
    <AuthField
      label={label}
      type={visible ? 'text' : 'password'}
      autoComplete="new-password"
      className={cn('vtwo:[&::-ms-reveal]:hidden', className)}
      endAdornment={
        <button
          type="button"
          aria-label={`${visible ? 'Hide' : 'Show'} ${label.toLowerCase()}`}
          onClick={() => setVisible((show) => !show)}
          className="vtwo:flex vtwo:size-8 vtwo:cursor-pointer vtwo:items-center vtwo:justify-center vtwo:rounded vtwo:text-auth-muted vtwo:outline-none vtwo:hover:text-auth-foreground vtwo:focus-visible:ring-2 vtwo:focus-visible:ring-auth-focus"
        >
          <Icon aria-hidden className="vtwo:size-4" />
        </button>
      }
      {...fieldProps}
    />
  );
}

export default PasswordField;
